import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/*When the pathname of the page changes, the page will render to the top. This fixes the issue  of changing
  pages in the middle/bottom of the page and having it go to the middle/bottom of the new page*/
//* this should be a custom React hook
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}